import React from 'react';
import PropTypes from 'prop-types';

const OrderIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
        <g>
            <path data-name="Path 1" d="M8 16a8 8 0 118-8 8 8 0 01-8 8zM5.411 8.179l1.587 1.488 3.252-4.189a.661.661 0 111.044.812l-3.7 4.76a.661.661 0 01-.974.076L4.504 9.143a.661.661 0 11.9-.965zM8 14.81A6.81 6.81 0 101.19 8 6.81 6.81 0 008 14.81z" fill={fill} />
        </g>
    </svg>
);

OrderIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

OrderIcon.defaultProps = {
    width: '16',
    height: '16',
    fill: '#4b254e'
};

export default OrderIcon;
